import React from 'react';

import styled from 'styled-components';

import Radio from 'components/lib/Radio';

import { useCompaniesCreateEditModalContext } from './CompaniesCreateEditModalContext';
import { COMPANY_KEYS, SHOP_TIME, SHOP_TIME_LABELS } from './constants';

const TextContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 15px;
`;

const Label = styled.div`
  font-size: 14px;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const Text = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-flow: column;
`;

const StyledRadioButton = styled(Radio)`
  font-family: var(--font-regular);
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  flex-flow: row;
  align-items: center;
`;

const CompaniesCreateEditModalContentMysteryShoppingShopTime = () => {
  const { company, handleChange } = useCompaniesCreateEditModalContext();
  const { shop_time = SHOP_TIME.MID_MONTH } = company?.mystery_shop_setting ?? {};

  const handleShopTimeChange = (event: any) => {
    const mystery_shop_setting = { ...company?.mystery_shop_setting };
    mystery_shop_setting.shop_time = event.target.value;
    handleChange(COMPANY_KEYS.MYSTERY_SHOP_SETTING, mystery_shop_setting);
  };

  return (
    <div>
      <TextContainer>
        <Label>Shop Time</Label>
        <Text>Choose whether shops are done in the early, mid or late part of the month.</Text>
      </TextContainer>
      <StyledRadioGroup value={shop_time} onChange={handleShopTimeChange}>
        {Object.values(SHOP_TIME).map((time) => (
          <StyledRadioButton key={time} value={time}>
            {SHOP_TIME_LABELS[time]}
          </StyledRadioButton>
        ))}
      </StyledRadioGroup>
    </div>
  );
};

export default CompaniesCreateEditModalContentMysteryShoppingShopTime;
